module.exports = __webpack_public_path__ + "img/TRACTOR_RHD_THUMB.80e72623.jpg";